import { ENDPOINTS } from '../constants/api';
/**
 * Request to get white label.
 *
 */
export function getWhiteLabels(language = 'en') {
  let endpoint = ENDPOINTS.whiteLabelData;
  return window.axios.get(endpoint, {params: {lang : language}});
}